/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiMembershipProduct } from './MembershipProduct';
import { ApiGiftItem } from './GiftItem';
import { ApiContribution } from './Contribution';
import { ApiGatewayMembershipStatus } from './GatewayMembershipStatus';

export interface MembershipRequest {

    id?: string;

    uuid?: string;

    product?: ApiMembershipProduct;

    renewed_at?: string;

    created_at?: string;

    refunded_at?: string;

    gateway_name?: string;

    payment_source?: string;

    /**
     * Amount charged (introductory price) to the user for this membership
     */
    introductory_price?: Number;

    /**
     * Number of periods to charge introductory price for
     */
    introductory_periods?: Number;

    purchased_at?: string;

    member_since?: string;

    /**
     * Amount charged (base price) to the user for this membership
     */
    price?: Number;

    period?: string;

    is_pay_what_you_want?: string;

    payment_status?: string;

    in_good_standing?: string;

    entitled?: string;

    cancelled_at?: string;

    modern?: string;

    subscription_identifier?: string;

    gift_item?: ApiGiftItem;

    contribution?: ApiContribution;

    cancelled?: string;

    message?: string;

    /**
     * (Deprecated) Whether this membership is charged annually or not (monthly)
     */
    annual?: boolean;

    payment_method?: string;

    status?: ApiGatewayMembershipStatus;

    renews_on?: string;

    complimentary?: string;

    /**
     * Membership active
     */
    active?: boolean;

    level?: ApiMembershipProduct;

}

@Model('Membership')
export class ApiMembership extends BaseModel implements MembershipRequest {

    
    
    id: string;

    
    
    uuid: string;

    @Type('ApiMembershipProduct')
    @Expand()
    product: ApiMembershipProduct;

    
    
    renewed_at: string;

    
    
    created_at: string;

    
    
    refunded_at: string;

    
    
    gateway_name: string;

    
    
    payment_source: string;

    /**
     * Amount charged (introductory price) to the user for this membership
     */
    
    
    introductory_price: Number;

    /**
     * Number of periods to charge introductory price for
     */
    
    
    introductory_periods: Number;

    
    
    purchased_at: string;

    
    
    member_since: string;

    /**
     * Amount charged (base price) to the user for this membership
     */
    
    
    price: Number;

    
    
    period: string;

    
    
    is_pay_what_you_want: string;

    
    
    payment_status: string;

    
    
    in_good_standing: string;

    
    
    entitled: string;

    
    
    cancelled_at: string;

    
    
    modern: string;

    
    
    subscription_identifier: string;

    @Type('ApiGiftItem')
    @Expand()
    gift_item: ApiGiftItem;

    @Type('ApiContribution')
    @Expand()
    contribution: ApiContribution;

    
    
    cancelled: string;

    
    
    message: string;

    /**
     * (Deprecated) Whether this membership is charged annually or not (monthly)
     */
    
    
    annual: boolean;

    
    
    payment_method: string;

    @Type('ApiGatewayMembershipStatus')
    @Expand()
    status: ApiGatewayMembershipStatus;

    
    
    renews_on: string;

    
    
    complimentary: string;

    /**
     * Membership active
     */
    
    
    active: boolean;

    @Type('ApiMembershipProduct')
    @Expand()
    level: ApiMembershipProduct;

}
